import { getCookie } from "@insite/client-framework/Common/Cookies";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { addToChainAfter, addToEndOfChain, Handler } from "@insite/client-framework/HandlerCreator";
import { GetProductCollectionApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import {
    chain,
    DisplayProductsResult,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import { dispatchProductImpressions } from "@store/Services/AnalyticsService"; // Store Custom Code

// Store Custom Code
const enum pageType {
    productListPage = "Product List Page",
    searchPage = "Search Page",
    promotionCategories = "Promotions",
}

export interface GetProductCollectionApiV2ParameterStore extends GetProductCollectionApiV2Parameter {
    ymme?: string;
}

interface Parameter {
    queryString: string;
    path: string;
    isSearch: boolean;
}
interface Props {
    apiParameter: GetProductCollectionApiV2ParameterStore;
    idByPath?: SafeDictionary<string>;
    result: DisplayProductsResult;
    pricingLoaded?: true;
}

type HandlerType = Handler<Parameter, Props>;

export const PopulateApiParameterWithYmme: HandlerType = props => {
    // todo: this code is reused at three places; make a service with it
    const make = getCookie("ymmContextMakeKey") ? getCookie("ymmContextMakeKey") : "";
    const model = getCookie("ymmContextModelKey") ? getCookie("ymmContextModelKey") : "";
    const year = getCookie("ymmContextYearKey") ? getCookie("ymmContextYearKey") : "";
    const engine = getCookie("ymmContextEngineKey") ? getCookie("ymmContextEngineKey") : "";
    const vehicle = `${make}${model}${year}${engine}`; // todo: use redux state instead of cookie `const state = props.getState();`
    if (vehicle !== "") {
        props.apiParameter.ymme = vehicle;
    }
};

// Store Custom Code
const dispatchProductImpressionsChain: HandlerType = props => {
    const state = props.getState();
    const currency = state.context.session.currency?.currencyCode;
    const { isSearch } = props.parameter;
    const { products } = props.result;
    const isPromo =
        typeof window !== "undefined"
            ? window.location.pathname.toLowerCase().includes("catalog/products/promotions")
            : false;
    let page = pageType.productListPage;
    if (isSearch) {
        page = pageType.searchPage;
    }
    if (isPromo) {
        page = pageType.promotionCategories;
    }
    if (products && products?.length > 0) {
        dispatchProductImpressions(products, currency, page);
    }
};

addToChainAfter(chain, PopulateApiParameter, PopulateApiParameterWithYmme);
addToEndOfChain(chain, dispatchProductImpressionsChain); // Store Custom Code
